import { ModalGallery } from './ModalGallery';

export type { TypeModalGalleryProps } from './types';
export default ModalGallery;
